var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.showModal)?_c('AccountModal',{on:{"closeModal":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.showSavedModal)?_c('SavedSpacesModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }